var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import ArtsApprovalService from "../services/ArtsApprovalService";
import Notification from "../../App/components/Notification";
import UploadingArtFiles from "./UploadingArtFiles";
import { handleServiceError } from "../../App/components/ErrorHandler";
import Modal from 'react-bootstrap/Modal';
import "../styles/ModalDisapprovalOfArt.css";
import ReactQuill from 'react-quill';
import Quill from 'quill';
import 'react-quill/dist/quill.snow.css';
import MemberHandbookService from "../../MemberHandbook/services/MemberHandbookService";
import { setClarityTag } from "../../App/utils/clarity";
import { notifyOpenerArtUpdated } from "../../App/utils/windowMessaging";
import { insertFormattedPlainText, createPlainTextClipboardMatcher } from "../../App/utils/quillPastePlainText";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DesignerInternalFields from "./DesignerInternalFields";
import useAuth from "../../App/hooks/useAuth";
import { designerRole } from "../../App/helpers/RoleHelper";
var NO_PRODUCT_KEY = "sem-produto";
function firstLine(text) {
    var line = text.split("\n")[0].trim();
    return line.length > 0 ? line : text.trim();
}
function buildDisapprovalProductTree(disapprovalOptions) {
    var products = new Map();
    function getProduct(key, name) {
        var product = products.get(key);
        if (!product) {
            product = { key: key, productName: name, labels: [] };
            products.set(key, product);
        }
        return product;
    }
    function getLabel(product, labelId, label) {
        var labelNode = product.labels.find(function (l) { return l.labelId === labelId; });
        if (!labelNode) {
            labelNode = { key: "".concat(product.key, "-label-").concat(labelId), labelId: labelId, label: label, leaves: [] };
            product.labels.push(labelNode);
        }
        return labelNode;
    }
    disapprovalOptions.forEach(function (option) {
        var _a;
        var groupTexts = (_a = option.product_group_texts) !== null && _a !== void 0 ? _a : [];
        if (groupTexts.length === 0) {
            var product = getProduct(NO_PRODUCT_KEY, "Outros");
            var labelNode = getLabel(product, option.id, option.label);
            labelNode.leaves.push({
                key: "label-".concat(option.id),
                labelId: option.id,
                caption: option.label,
                text: null,
            });
            return;
        }
        groupTexts.forEach(function (pgt) {
            var _a, _b;
            var productKey = pgt.content_supplier_product_group ? String(pgt.content_supplier_product_group.id) : NO_PRODUCT_KEY;
            var productName = (_b = (_a = pgt.content_supplier_product_group) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Outros";
            var product = getProduct(productKey, productName);
            var labelNode = getLabel(product, option.id, option.label);
            labelNode.leaves.push({
                key: "pgt-".concat(pgt.id),
                labelId: option.id,
                caption: pgt.text ? firstLine(pgt.text) : option.label,
                text: pgt.text,
            });
        });
    });
    return Array.from(products.values()).sort(function (a, b) { return a.productName.localeCompare(b.productName); });
}
function ModalDisapprovalOfArt(props) {
    var _a = useState([]), disapprovalOptions = _a[0], setDisapprovalOptions = _a[1];
    var _b = useState([]), checkedDisapprovalOptions = _b[0], setCheckedDisapprovalOptions = _b[1];
    var _c = useState(new Set()), checkedLeafKeys = _c[0], setCheckedLeafKeys = _c[1];
    var _d = useState(''), justification = _d[0], setJustification = _d[1];
    var _e = useState(), file = _e[0], setFile = _e[1];
    var _f = useState(), materialLinkURL = _f[0], setMaterialLinkURL = _f[1];
    var _g = useState(new Set()), expandedProductKeys = _g[0], setExpandedProductKeys = _g[1];
    var _h = useState(new Set()), expandedLabelKeys = _h[0], setExpandedLabelKeys = _h[1];
    var _j = useState(''), ticketArtsCount = _j[0], setTicketArtsCount = _j[1];
    var _k = useState(null), usedTemplate = _k[0], setUsedTemplate = _k[1];
    var _l = useState([]), selectedProductGroupIds = _l[0], setSelectedProductGroupIds = _l[1];
    var auth = useAuth().auth;
    var isDesigner = auth.role_id === designerRole;
    var _m = useState('reasons'), step = _m[0], setStep = _m[1];
    var params = useParams();
    var artId = params.art_id;
    var quillRef = useRef(null);
    var autoTextLengthRef = useRef(0);
    var isPlainTextPasteRef = useRef(false);
    var productTree = useMemo(function () { return buildDisapprovalProductTree(disapprovalOptions); }, [disapprovalOptions]);
    var allLeaves = useMemo(function () { return productTree.flatMap(function (product) { return product.labels.flatMap(function (labelNode) { return labelNode.leaves; }); }); }, [productTree]);
    useEffect(function () {
        getArtDisapprovalArts();
        setDisapprovalOptions([]);
        setFile(undefined);
        setJustification('');
        setCheckedLeafKeys(new Set());
        setExpandedProductKeys(new Set());
        setExpandedLabelKeys(new Set());
        setTicketArtsCount('');
        setUsedTemplate(null);
        setSelectedProductGroupIds([]);
        setStep('reasons');
        autoTextLengthRef.current = 0;
    }, [props.artHistories]);
    function toggleLabelExpanded(labelKey) {
        setExpandedLabelKeys(function (prevExpandedLabelKeys) {
            var next = new Set(prevExpandedLabelKeys);
            if (next.has(labelKey)) {
                next.delete(labelKey);
            }
            else {
                next.add(labelKey);
            }
            return next;
        });
    }
    ;
    function toggleProductExpanded(productKey) {
        setExpandedProductKeys(function (prevExpandedProductKeys) {
            var next = new Set(prevExpandedProductKeys);
            if (next.has(productKey)) {
                next.delete(productKey);
            }
            else {
                next.add(productKey);
            }
            return next;
        });
    }
    ;
    useEffect(function () {
        var _a;
        var checkedLeaves = allLeaves.filter(function (leaf) { return checkedLeafKeys.has(leaf.key); });
        setCheckedDisapprovalOptions(Array.from(new Set(checkedLeaves.map(function (leaf) { return leaf.labelId; }))));
        var editor = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor();
        if (!editor) {
            return;
        }
        var texts = checkedLeaves
            .map(function (leaf) { return (leaf.text && leaf.text.trim() !== "") ? leaf.text : leaf.caption; })
            .filter(function (text) { return !!text && text.trim() !== ""; });
        if (autoTextLengthRef.current > 0) {
            var deleteStart = Math.max(0, editor.getLength() - 1 - autoTextLengthRef.current);
            editor.deleteText(deleteStart, autoTextLengthRef.current, 'silent');
        }
        autoTextLengthRef.current = texts.length > 0
            ? insertFormattedPlainText(editor, "".concat(texts.join('\n\n'), "\n\n"), editor.getLength() - 1, 'silent')
            : 0;
    }, [checkedLeafKeys, allLeaves]);
    useEffect(function () {
        getTheMaterialLink();
    }, []);
    useEffect(function () {
        var _a;
        var editor = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor();
        var editorRoot = editor === null || editor === void 0 ? void 0 : editor.root;
        if (!editor || !editorRoot) {
            return;
        }
        var Delta = Quill.import('delta');
        editor.clipboard.addMatcher('strong', function (_node, delta) { return (delta.compose(new Delta().retain(delta.length(), { bold: true }))); });
        editor.clipboard.addMatcher('em', function (_node, delta) { return (delta.compose(new Delta().retain(delta.length(), { italic: true }))); });
        editor.clipboard.addMatcher(Node.ELEMENT_NODE, function (node, delta) {
            var _a;
            var inlineStyle = node.style;
            var isItalic = (inlineStyle === null || inlineStyle === void 0 ? void 0 : inlineStyle.fontStyle) === 'italic';
            var inlineFontWeight = inlineStyle === null || inlineStyle === void 0 ? void 0 : inlineStyle.fontWeight;
            var hasExplicitBold = !!inlineFontWeight && (inlineFontWeight.toLowerCase().startsWith('bold') || parseInt(inlineFontWeight, 10) >= 700);
            if (isItalic && !hasExplicitBold) {
                (_a = delta.ops) === null || _a === void 0 ? void 0 : _a.forEach(function (op) {
                    var _a;
                    if ((_a = op.attributes) === null || _a === void 0 ? void 0 : _a.bold) {
                        delete op.attributes.bold;
                    }
                });
            }
            return delta;
        });
        editor.clipboard.addMatcher(Node.TEXT_NODE, createPlainTextClipboardMatcher(isPlainTextPasteRef));
        function handlePaste(event) {
            var _a;
            var clipboardData = event.clipboardData;
            var hasRichHtml = !!(clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.types.includes('text/html'));
            var hasFileItem = !!clipboardData && Array.from((_a = clipboardData.items) !== null && _a !== void 0 ? _a : []).some(function (item) { return item.kind === 'file'; });
            var hasFiles = !!(clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.files.length) || !!(clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.types.includes('Files')) || hasFileItem;
            isPlainTextPasteRef.current = !!clipboardData && !hasRichHtml && !hasFiles;
            setTimeout(function () {
                isPlainTextPasteRef.current = false;
            }, 0);
        }
        editorRoot.addEventListener('paste', handlePaste);
        return function () { return editorRoot.removeEventListener('paste', handlePaste); };
    }, []);
    function getArtDisapprovalArts() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtsApprovalService.getArtDisapprovalOptions()
                            .then(function (res) {
                            setDisapprovalOptions(res.data.message);
                        }, function (error) {
                            Notification().Notify.failure(error.response.data.error);
                            Notification().Block.remove("[data-id=arts-grid]");
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function sendEmailDisapproved(_a) {
        var checkedDisapprovalOptions = _a.checkedDisapprovalOptions, justification = _a.justification, file = _a.file, art_id = _a.art_id;
        var formData = new FormData();
        formData.append('checkedDisapprovalOptions', JSON.stringify(checkedDisapprovalOptions));
        formData.append('justification', "".concat(justification));
        if (art_id !== undefined) {
            formData.append('art_id', art_id.toString());
        }
        ;
        if (file !== undefined) {
            formData.append('file', file);
        }
        ;
        if (isDesigner) {
            if (ticketArtsCount !== '') {
                formData.append('ticket_arts_count', ticketArtsCount);
            }
            ;
            if (usedTemplate !== null) {
                formData.append('used_template', usedTemplate ? '1' : '0');
            }
            ;
            if (selectedProductGroupIds.length > 0) {
                formData.append('content_supplier_product_group_ids', JSON.stringify(selectedProductGroupIds));
            }
            ;
        }
        ;
        ArtsApprovalService.sendEmailDisapproved(formData).then(function (res) {
            Notification().Block.circle("[data-id=arts-grid]");
            Notification().Notify.success("E-mail de reprovação enviado com sucesso!");
            notifyOpenerArtUpdated();
            window.location.reload();
        }, function (error) {
            handleServiceError(error);
        });
    }
    ;
    function handleLeafCheckChange(key, checked) {
        setCheckedLeafKeys(function (prevCheckedLeafKeys) {
            var next = new Set(prevCheckedLeafKeys);
            if (checked) {
                next.add(key);
            }
            else {
                next.delete(key);
            }
            return next;
        });
    }
    ;
    function handleFileEmail(file) {
        setFile(file);
    }
    ;
    function getTheMaterialLink() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MemberHandbookService.memberHandbookURL().then(function (res) {
                            setMaterialLinkURL(res.data.arts_url);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    return (_jsx(_Fragment, { children: props.artHistories &&
            _jsxs(Modal, __assign({ show: props.openModalToDisapproveArt, onHide: props.closeModalToDisapproveArt, "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "modal-disapproval-of-art" }, { children: [_jsxs(Modal.Body, { children: [step === 'reasons' && _jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("p", { children: "Motivos para a reprova\u00E7\u00E3o:" }), _jsx("div", __assign({ className: "disapproval-options-tree" }, { children: productTree.map(function (product) {
                                                    var isExpanded = expandedProductKeys.has(product.key);
                                                    var leafCount = product.labels.reduce(function (sum, labelNode) { return sum + labelNode.leaves.length; }, 0);
                                                    var checkedCount = product.labels.reduce(function (sum, labelNode) { return sum + labelNode.leaves.filter(function (leaf) { return checkedLeafKeys.has(leaf.key); }).length; }, 0);
                                                    return (_jsxs("div", __assign({ className: "disapproval-product-group" }, { children: [_jsxs("button", __assign({ type: "button", className: "disapproval-product-header", onClick: function () { return toggleProductExpanded(product.key); }, "aria-expanded": isExpanded }, { children: [isExpanded ? _jsx(KeyboardArrowUpIcon, { fontSize: "small" }) : _jsx(KeyboardArrowDownIcon, { fontSize: "small" }), _jsx("span", __assign({ className: "disapproval-product-title" }, { children: product.productName })), _jsx("span", __assign({ className: "disapproval-product-count" }, { children: checkedCount > 0 ? "".concat(checkedCount, "/").concat(leafCount) : leafCount }))] })), isExpanded && product.labels.map(function (labelNode) {
                                                                var isLabelExpanded = expandedLabelKeys.has(labelNode.key);
                                                                var checkedLeafCount = labelNode.leaves.filter(function (leaf) { return checkedLeafKeys.has(leaf.key); }).length;
                                                                return (_jsxs("div", __assign({ className: "disapproval-label-group" }, { children: [_jsxs("button", __assign({ type: "button", className: "disapproval-label-header", onClick: function () { return toggleLabelExpanded(labelNode.key); }, "aria-expanded": isLabelExpanded }, { children: [isLabelExpanded ? _jsx(KeyboardArrowUpIcon, { fontSize: "small" }) : _jsx(KeyboardArrowDownIcon, { fontSize: "small" }), _jsx("span", __assign({ className: "disapproval-label-title" }, { children: labelNode.label })), _jsx("span", __assign({ className: "disapproval-product-count" }, { children: checkedLeafCount > 0 ? "".concat(checkedLeafCount, "/").concat(labelNode.leaves.length) : labelNode.leaves.length }))] })), isLabelExpanded && labelNode.leaves.map(function (leaf) { return (_jsxs("div", __assign({ className: "modal-disapproval-of-art-labels disapproval-leaf" }, { children: [_jsx("input", { type: "checkbox", id: leaf.key, checked: checkedLeafKeys.has(leaf.key), onChange: function (event) { return handleLeafCheckChange(leaf.key, event.target.checked); } }), " ", _jsx("label", __assign({ style: { marginLeft: "0.5rem;" }, htmlFor: leaf.key }, { children: leaf.caption }))] }), leaf.key)); })] }), labelNode.key));
                                                            })] }), product.key));
                                                }) })), _jsx(UploadingArtFiles, { pageName: "aproval_arts", handleFileEmail: handleFileEmail })] }), _jsxs("div", { children: [_jsx("p", { children: "Justificativa:" }), _jsx("div", { children: _jsx("p", __assign({ className: "text-black-50 fw-normal mb-0 second-text" }, { children: "Ol\u00E1, provedor! Recebemos a sua arte e agradecemos seu esfor\u00E7o e colabora\u00E7\u00E3o! Confira abaixo os motivos da reprova\u00E7\u00E3o:" })) }), _jsx("div", { children: _jsx(ReactQuill, { ref: quillRef, theme: "snow", value: justification, onChange: setJustification, className: "textarea-justification" }) }), _jsx("div", { children: _jsxs("p", __assign({ className: "text-black-50 fw-normal mb-0 second-text" }, { children: ["Relembramos que, voc\u00EA pode encontrar todos os recursos que precisa na \u00EDntegra dentro do nosso drive: ", ' ', _jsxs("a", __assign({ href: materialLinkURL !== null && materialLinkURL !== void 0 ? materialLinkURL : "#", target: "_blank", rel: "noopener noreferrer", className: "text-black-50 fw-normal mb-0 mt-1 second-text" }, { children: ["LINK: ", materialLinkURL] })), _jsx("br", {})] })) })] })] }), step === 'designer-fields' &&
                                _jsx(DesignerInternalFields, { ticketArtsCount: ticketArtsCount, onChangeTicketArtsCount: setTicketArtsCount, usedTemplate: usedTemplate, onChangeUsedTemplate: setUsedTemplate, selectedProductGroupIds: selectedProductGroupIds, onChangeSelectedProductGroupIds: setSelectedProductGroupIds })] }), _jsxs(Modal.Footer, __assign({ style: {
                            backgroundColor: '#fff',
                            padding: '15px',
                            marginTop: '-7rem',
                        } }, { children: [step === 'reasons' && _jsxs(_Fragment, { children: [_jsx("button", __assign({ id: "btn-disapproval-close", onClick: props.closeModalToDisapproveArt, className: "button-with-orange-border" }, { children: "Fechar" })), _jsx("button", __assign({ id: "btn-disapproval-send", onClick: function () {
                                            setClarityTag("actionType", "ticket-history-disapprove-confirm-click");
                                            if (checkedDisapprovalOptions.length === 0 && justification.trim() === "" && file === undefined) {
                                                Notification().Notify.failure("Preencha os campos");
                                            }
                                            else if (isDesigner) {
                                                setStep('designer-fields');
                                            }
                                            else {
                                                Notification().Confirm.show("Reprovar arte", "Tem certeza que deseja reprovar a arte?", "Cancelar", "Reprovar", function () {
                                                    props.closeModalToDisapproveArt();
                                                }, function () {
                                                    sendEmailDisapproved({ checkedDisapprovalOptions: checkedDisapprovalOptions, justification: justification, file: file, art_id: artId });
                                                    props.closeModalToDisapproveArt();
                                                }, {
                                                    okButtonBackground: "#ccc",
                                                    cancelButtonBackground: "#F44336"
                                                });
                                            }
                                        }, className: "orange-btn" }, { children: isDesigner ? "Próximo" : "Enviar" }))] }), step === 'designer-fields' && _jsxs(_Fragment, { children: [_jsx("button", __assign({ id: "btn-disapproval-back", onClick: function () { return setStep('reasons'); }, className: "button-with-orange-border" }, { children: "Voltar" })), _jsx("button", __assign({ id: "btn-disapproval-send", onClick: function () {
                                            setClarityTag("actionType", "ticket-history-disapprove-confirm-click");
                                            Notification().Confirm.show("Reprovar arte", "Tem certeza que deseja reprovar a arte?", "Cancelar", "Reprovar", function () {
                                                props.closeModalToDisapproveArt();
                                            }, function () {
                                                sendEmailDisapproved({ checkedDisapprovalOptions: checkedDisapprovalOptions, justification: justification, file: file, art_id: artId });
                                                props.closeModalToDisapproveArt();
                                            }, {
                                                okButtonBackground: "#ccc",
                                                cancelButtonBackground: "#F44336"
                                            });
                                        }, className: "orange-btn" }, { children: "Enviar" }))] })] }))] }), props.artHistories.art_id) }));
}
export default ModalDisapprovalOfArt;
